import 'ui-core/plugins/scrollo/js/scrollo';

UX.scrollo.get.fixedpageElementsHeight = function () {
    let elementsHeight = 0;

    if (UX.pageBody && UX.pageBody.get && UX.pageBody.get.headerHeight) {
        elementsHeight += UX.pageBody.get.headerHeight();
    } else {
        const $fixedHeader = $('header.fixed, .pageHeader');
        if ($fixedHeader.length) {
            elementsHeight += $fixedHeader.outerHeight();
        }
    }

    const $scrolloThenFix = $('.scrollThenFix');
    if ($scrolloThenFix.length) {
        elementsHeight = $scrolloThenFix.outerHeight();
    }

    const $stickyCoolbar = $('.coolBar.stickybar--sticky');
    let stickyCoolbarHeigh = 0;
    if ($stickyCoolbar.length) {
        stickyCoolbarHeigh = $stickyCoolbar.outerHeight();
        if (stickyCoolbarHeigh === 0) {
            stickyCoolbarHeigh = $stickyCoolbar.find('.stickybar__wrapper').outerHeight();
        }
        elementsHeight += stickyCoolbarHeigh;
    }

    if ($('.coolBar--res').length) {
        $.each($('.coolBar--res'), function (index, value) {
            if ($(value).outerHeight()) {
                elementsHeight += $(value).outerHeight();
            }
        });
    }

    return elementsHeight;
};
